import { SET_APP_LOGO, SET_FOOTER_NAVIGATE, SET_IDENTIFICATION_METHODS, SET_ACCESS_LEVEL, SET_APP_DATA } from "../actions/appSettingsActions";
import type { AppSettingsAction } from "../actions/appSettingsActions";
import type { AppSettingsState } from "../../types/redux";

const initialState: AppSettingsState = {
    appLogo: '',
    identification: [],
    showNavigate: false,
    accessLevel: 'public',
    nextUrl: '',
}

const appSettingsReducer = (state: AppSettingsState = initialState, action: AppSettingsAction): AppSettingsState => {
    switch (action.type) {
        case SET_APP_DATA: {
            return {
                ...state,
                appLogo: action.payload.logo_image,
                identification: action.payload.identification_methods,
                accessLevel: action.payload.access_level,
                layout: action.payload.layout,
                name: action.payload.name,
                description: action.payload.description,
                nextUrl: action.payload.next_url,
                terminology: action.payload.terminology || null,
            }
        }
        case SET_APP_LOGO: 
            return {
                ...state,
                appLogo: action.payload
            }
        case SET_FOOTER_NAVIGATE: {
            return {
                ...state,
                showNavigate: action.payload
            }
        }
        case SET_IDENTIFICATION_METHODS: {
            return {
                ...state,
                identification: action.payload
            }
        }
        case SET_ACCESS_LEVEL: {
            return {
                ...state,
                accessLevel: action.payload
            }
        }
        default:
            return state
    }
}

export default appSettingsReducer;
